export default {
  usuario: {},
  authToken: localStorage.getItem('auth_token') || null,
  company: null,
};
